// Namespaces
import * as ProposalElementNS from './ProposalElements';
import * as ProposalNS from './Proposal';
import Nullable from '@/types/nullable';
import Dictionary from '@/types/dictionary';

export class ProposalUtils {
  public static getColors(key: string, proposalElement?: ProposalElementNS.ProposalElement): Nullable<Dictionary<string>> {
    let workElement: ProposalElementNS.ProposalElement | null = proposalElement !== undefined ? proposalElement : null;

    while (workElement != null) {
      const { settings } = workElement;

      if (settings && settings.colors && settings.colors[key]) {
        return settings.colors[key];
      }

      workElement = workElement.parent ? workElement.parent : null;
    }

    return null;
  }

  public static getAllowedItemTypes(proposalElement?: ProposalElementNS.ProposalElement): ProposalNS.ProposalAllowedItemType[] | undefined {
    let workElement: ProposalElementNS.ProposalElement | null = proposalElement !== undefined ? proposalElement : null;

    while (workElement != null) {
      if (
        workElement.type === ProposalNS.ProposalTemplateElementType.Section &&
        workElement.allowedItemTypes != null &&
        workElement.allowedItemTypes.length > 0
      ) {
        // we currently do not have sections in sections, so we can stop here.
        return workElement.allowedItemTypes;
      }

      workElement = workElement.parent ? workElement.parent : null;
    }

    return undefined;
  }
}
